<div class="user-access-add-popup-content" style="text-align: left; width: 100%;">
  <div class="d-flex justify-content-start align-items-center gap-4 m-0">
    <!-- Centered loader while fetching data -->
    @if (showLoader) {
    <div class="flex-grow-1 d-flex justify-content-center align-items-center">
      <app-loader></app-loader>
    </div>
    }
    <!-- Dropdowns after loading -->
    @if (!showLoader) {
    <div class="mb-3" style="min-width: 150px;">
      <label class="section-name tabl-header tabl-header-font">Role</label>
      <span class="d-block">{{ displayRole }}</span>
    </div>
    @for (field of popupFields; track field) {
    <div class="mb-3">
      <label class="section-name tabl-header tabl-header-font">{{ field.label }}</label>
      @switch (field.type) { @case ('hierarchical') { @if (getHierarchyData(field).length) {
      <div>
        <app-multiselect-group-checkbox
          [dropdowndataSource]="getHierarchyData(field)"
          [hierarchyDropdownConfig]="getHierarchyConfig(field)"
          [selectValues]="[]"
          [openAllPanel]="false"
          [placeholderText]="'Select ' + field.label"
          (selectedHierarchy)="onHierarchySelectionChange(field, $event)"
        ></app-multiselect-group-checkbox>
      </div>
      } } @case ('singleselect') {
      <div>
        <app-dropdown-with-search
          [Pixeltracking]="'false'"
          [showPlaceholder]="'false'"
          searchFlag="true"
          isMultiSelect="false"
          [dropdownData]="getFieldDropdownData(field)"
          [selected]="getFieldSelected(field)"
          (selectionChange)="onFieldSelectionChange(field, $event)"
        ></app-dropdown-with-search>
      </div>
      } @case ('multiselect') {
      <div>
        <app-dropdown-with-search
          [Pixeltracking]="'false'"
          [showPlaceholder]="'false'"
          searchFlag="true"
          isMultiSelect="true"
          [dropdownData]="getFieldDropdownData(field)"
          [selected]="getFieldSelected(field)"
          [disableDD]="isFieldDisabled(field)"
          (selectionChange)="onFieldSelectionChange(field, $event)"
        ></app-dropdown-with-search>
      </div>
      } }
    </div>
    } }
  </div>

  <div class="form-footer d-flex justify-content-end" style="padding: 1rem 0 0; gap: 0.5rem;">
    @if (popupFields.length > 0) {
    <button
      mat-raised-button
      class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button"
      [disabled]="isSubmitDisabled"
      (click)="onSubmit()"
    >
      Submit
    </button>
    }
    <button
      mat-raised-button
      class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button"
      (click)="onClose()"
    >
      Close
    </button>
  </div>
</div>
